(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$_createEmptyBoard = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_generateSquare = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_isWin = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_isGameOver = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_move = /*#__PURE__*/ new WeakSet();
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_createEmptyBoard);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_generateSquare);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isWin);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isGameOver);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move);
        this.initialState = initialState;
        this.board = initialState || (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_createEmptyBoard, $3d28d7f1aac198f5$var$createEmptyBoard).call(this);
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "down");
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_createEmptyBoard, $3d28d7f1aac198f5$var$createEmptyBoard).call(this);
                this.score = 0;
                this.status = "playing";
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_generateSquare, $3d28d7f1aac198f5$var$generateSquare).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_generateSquare, $3d28d7f1aac198f5$var$generateSquare).call(this);
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isWin, $3d28d7f1aac198f5$var$isWin).call(this)) this.status = "win";
                else if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_isGameOver, $3d28d7f1aac198f5$var$isGameOver).call(this)) this.status = "lose";
            }
        }
    ]);
    return Game;
}();
function $3d28d7f1aac198f5$var$createEmptyBoard() {
    return Array.from({
        length: 4
    }, function() {
        return Array(4).fill(0);
    });
}
function $3d28d7f1aac198f5$var$generateSquare() {
    var emptyCells = [];
    for(var r = 0; r < 4; r++){
        for(var c = 0; c < 4; c++)if (this.board[r][c] === 0) emptyCells.push({
            row: r,
            col: c
        });
    }
    if (emptyCells.length > 0) {
        var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], row = _emptyCells_Math_floor.row, col = _emptyCells_Math_floor.col;
        var value = Math.random() < 0.1 ? 4 : 2;
        this.board[row][col] = value;
    }
}
function $3d28d7f1aac198f5$var$isWin() {
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        if (this.board[r][c] === 2048) return true;
    }
    return false;
}
function $3d28d7f1aac198f5$var$isGameOver() {
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        if (this.board[r][c] === 0) return false;
    }
    for(var r1 = 0; r1 < 4; r1++)for(var c1 = 0; c1 < 4; c1++){
        var val = this.board[r1][c1];
        if (c1 < 3 && this.board[r1][c1 + 1] === val) return false;
        if (r1 < 3 && this.board[r1 + 1][c1] === val) return false;
    }
    return true;
}
function $3d28d7f1aac198f5$var$move(direction) {
    var _this = this, _loop = function(i) {
        var rowOrCol = [];
        if (direction === "up") for(var j = 0; j < 4; j++)rowOrCol.push(_this.board[j][i]);
        else if (direction === "down") for(var j1 = 0; j1 < 4; j1++)rowOrCol.push(_this.board[3 - j1][i]);
        else if (direction === "left") rowOrCol = _this.board[i];
        else if (direction === "right") rowOrCol = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[i]).reverse();
        var newRowOrCol = rowOrCol.filter(function(val) {
            return val !== 0;
        });
        for(var j2 = 0; j2 < newRowOrCol.length - 1; j2++)if (newRowOrCol[j2] === newRowOrCol[j2 + 1]) {
            newRowOrCol[j2] *= 2;
            _this.score += newRowOrCol[j2];
            newRowOrCol.splice(j2 + 1, 1);
        }
        while(newRowOrCol.length < 4)newRowOrCol.push(0);
        if (direction === "up") for(var j3 = 0; j3 < 4; j3++)_this.board[j3][i] = newRowOrCol[j3];
        else if (direction === "down") for(var j4 = 0; j4 < 4; j4++)_this.board[3 - j4][i] = newRowOrCol[j4];
        else if (direction === "left") _this.board[i] = newRowOrCol;
        else if (direction === "right") _this.board[i] = newRowOrCol.reverse();
    };
    if (this.status !== "playing") return false;
    var previousBoard = JSON.parse(JSON.stringify(this.board));
    var moved = false;
    for(var i = 0; i < 4; i++)_loop(i);
    if (JSON.stringify(this.board) !== JSON.stringify(previousBoard)) {
        (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_generateSquare, $3d28d7f1aac198f5$var$generateSquare).call(this);
        moved = true;
    }
    this.checkStatus();
    return moved;
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$gameScoreText = document.querySelector(".game-score");
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field tbody");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$arrowLeftButton = document.querySelector("#arrow-left");
var $197cd56b15c33885$var$arrowUpButton = document.querySelector("#arrow-up");
var $197cd56b15c33885$var$arrowRightButton = document.querySelector("#arrow-right");
var $197cd56b15c33885$var$arrowDownButton = document.querySelector("#arrow-down");
var $197cd56b15c33885$var$updateUI = function() {
    var board = $197cd56b15c33885$var$game.getState();
    var cells = $197cd56b15c33885$var$gameField.querySelectorAll(".field-cell");
    cells.forEach(function(cell) {
        cell.textContent = "";
        cell.className = "field-cell";
    });
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        var value = board[r][c];
        var cell = cells[r * 4 + c];
        if (value !== 0) {
            cell.textContent = value;
            cell.classList.add("field-cell--".concat(value));
        }
    }
    $197cd56b15c33885$var$gameScoreText.textContent = $197cd56b15c33885$var$game.getScore();
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    $197cd56b15c33885$var$startMessage.classList.add("hidden");
    if (gameStatus === "win") $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    else if (gameStatus === "lose") $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
    if (gameStatus === "idle") {
        $197cd56b15c33885$var$startMessage.classList.remove("hidden");
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
    } else {
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    }
    var isPlaying = gameStatus === "playing";
    $197cd56b15c33885$var$arrowUpButton.disabled = !isPlaying;
    $197cd56b15c33885$var$arrowDownButton.disabled = !isPlaying;
    $197cd56b15c33885$var$arrowLeftButton.disabled = !isPlaying;
    $197cd56b15c33885$var$arrowRightButton.disabled = !isPlaying;
};
var $197cd56b15c33885$var$handleMove = function(e) {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        switch(e.key){
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                break;
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                break;
        }
        $197cd56b15c33885$var$updateUI();
    }
};
document.addEventListener("DOMContentLoaded", function() {
    $197cd56b15c33885$var$updateUI();
});
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateUI();
});
document.addEventListener("keydown", $197cd56b15c33885$var$handleMove);
$197cd56b15c33885$var$arrowUpButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.moveUp();
        $197cd56b15c33885$var$updateUI();
    }
});
$197cd56b15c33885$var$arrowDownButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$updateUI();
    }
});
$197cd56b15c33885$var$arrowLeftButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.moveLeft();
        $197cd56b15c33885$var$updateUI();
    }
});
$197cd56b15c33885$var$arrowRightButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.moveRight();
        $197cd56b15c33885$var$updateUI();
    }
});

})();
//# sourceMappingURL=index.114cafdc.js.map
